import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

// Heroicons solid "play" (a plain filled triangle, not the circled outline glyph in Play.tsx used
// elsewhere for GL code toggling) - Figma's icon for "Enable these team members" (a restorative
// action, same accent/teal circle as Update access - see ConfirmActionModal's ICON_TONE_CLASS).
const PlaySolid = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ size, variant, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 11.3054C9 8.45313 12.058 6.64502 14.5572 8.01958L37.6384 20.7142C40.2288 22.1389 40.2288 25.8611 37.6384 27.2858L14.5572 39.9805C12.058 41.355 9 39.5469 9 36.6947V11.3054Z"
      fill="currentColor"
    />
  </svg>
);

export default PlaySolid;
